const drawArc = ({
  cx = 0,
  cy = 0,
  r,
  start,
  end,
  fillStyle,
  strokeStyle,
  lineWidth = 2,
  invert,
  context,
}) => {
  context.beginPath()
  context.arc(cx, cy, r, start, end, invert)
  if (fillStyle) {
    context.fillStyle = fillStyle
    context.fill()
  }

  if (strokeStyle) {
    context.strokeStyle = strokeStyle
    context.lineWidth = lineWidth
    context.stroke()
  }
  context.closePath()
}

export default drawArc
